import { Dispatch, SetStateAction } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SidebarIcon, SidebarNavLinks } from '../../../helpers/helperFunctions';
import { DASHBOARD } from '../../../routes/routes';
import { P2 } from '../../../styles/FontStyles';
import { colors, globalImages } from '../../../styles/GlobalStyles';
import { Icon } from '../../../styles/Icons';
import { FlexCenter } from '../../../styles/stylesStyled';
import { SideButtonsContent } from '../BackofficeLayoutStyled';

interface SidebarNavContentProps {
  onClose: Dispatch<SetStateAction<boolean>>;
}

export const SidebarNavContent = ({ onClose }: SidebarNavContentProps) => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <SideButtonsContent>
      <Link to={DASHBOARD}>
        <img src={globalImages.appLogo} alt='logo' style={{ width: 150 }} />
      </Link>
      {SidebarNavLinks().map(({ link, name, disabled, hidden }, i) => {
        if (hidden) return null;

        return (
          <Link
            to={link}
            key={i}
            style={{
              pointerEvents: disabled ? 'none' : 'auto'
            }}
            onClick={() => onClose(false)}>
            <FlexCenter
              style={{
                opacity: disabled ? 0.3 : 1
              }}>
              <Icon
                m='15px'
                mSM='10px 20px'
                w='32px'
                color={
                  link === pathname ? colors.primary900 : colors.neutral900
                }>
                <SidebarIcon link={name} />
              </Icon>
              <P2
                semiBold
                color={
                  link === pathname ? colors.primary900 : colors.neutral900
                }>
                {name}
              </P2>
            </FlexCenter>
          </Link>
        );
      })}
    </SideButtonsContent>
  );
};
